import { Role } from '../../../../types/auth';

export const getData = (t: (key: string) => string) => [
  {
    title: t('pages:communications.new'),
    path: '',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
    subItems: [
      {
        text: t('pages:communications.duplicate'),
        path: 'duplicate-communication',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
      },
    ],
  },
];

// Para compatibilidad con imports existentes - usar valores por defecto
export const data = [
  {
    title: 'Nova comunicació',
    path: '',
    permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
    subItems: [
      {
        text: 'Duplicar comunicació',
        path: 'duplicate-communication',
        permissions: [Role.Coex, Role.Capataz, Role.SuperAdmin, Role.RoomTeam],
      },
    ],
  },
];
